export default __webpack_public_path__ + "static/media/uploadGloves.8761c77c.png";